module.exports = __webpack_public_path__ + "img/bakingIngredient7.0c46b703.jpeg";